<h4>{{'MOBILE_WHITELIST' |translate}}</h4>
@if (mobileWhitelist.length > 0) {
  <div class="row">
    <div class="col-lg-12">
      <div class="mb-2">
        <strong>{{'WAITING_APPROVAL' |translate}}
        </strong>
      </div>
      @if (mobileWhitelist |filter:'approved':false; as whitelist) {
        @if (whitelist.length) {
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th style="width:18.75%">{{'PHONE_NAME' |translate}}</th>
                <th style="width:18.75%">{{'GSM_NUMBER' |translate}}</th>
                <th style="width:18.75%">{{'REQUESTED_BY' |translate}}</th>
                <th style="width:18.75%">{{'REQUESTED_AT' |translate}}</th>
                <th style="width:25%">{{'APPROVE_DENY' |translate}}</th>
              </tr>
            </thead>
            <tbody>
              @for (mobile of whitelist; track mobile) {
                <tr>
                  @if (!mobile.toBeDeleted) {
                    <td>{{mobile.name}}</td>
                    <td>{{mobile.gsmNumber ? mobile.gsmNumber : '-'}}</td>
                    <td>@if (mobile.modifiedStaff) {
                      <a class="underline"
                      [routerLink]="'../staff/'+mobile.modifiedStaff">{{mobile.modifiedStaff}}</a>
                    }</td>
                    <td>{{mobile.modified |moment:'l LTS'}}</td>
                    <td>
                      <span class="text-success cursorPointer" (click)="approveMobile(mobile)"><span
                      class="fa-light fa-fw fa-check"></span> {{'APPROVE' |translate}}</span>
                      <span class="ml-3 text-danger cursorPointer" (click)="mobile.toBeDeleted = true"><span
                      class="fa-light fa-fw fa-ban"></span> {{'DENY' |translate}}</span>
                    </td>
                  }
                  @if (mobile.toBeDeleted) {
                    <td colspan="5">
                      {{'CONFIRM_MOBILE_DELETION' |translate: {mobile: mobile.name} }}
                      <span class="ml-3 text-danger cursorPointer" (click)="denyMobile(mobile)"><span
                      class="fa-light fa-fw fa-xmark"></span> {{'BLOCK_MOBILE' |translate}}</span>
                      <span class="ml-3 text-primary cursorPointer" (click)="mobile.toBeDeleted = false"><span
                      class="fa-light fa-fw fa-xmark"></span> {{'CANCEL' |translate}}</span>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        }
        @if (!whitelist.length) {
          <div>{{'NO_APPROVE_REQUESTS' |translate}}</div>
        }
      }
    </div>
  </div>
}
<hr>
  @if (mobileWhitelist.length > 0) {
    <div class="row mt-3">
      <div class="col-lg-12">
        <div>
          <strong>{{'APPROVED_MOBILES' |translate}}</strong>
        </div>
        @if (mobileWhitelist |filter:'approved':true; as whitelist) {
          @if (whitelist.length) {
            <table class="table table-sm table-striped" matSort (matSortChange)="sortWhitelist($event)">
              <thead>
                <tr>
                  <th style="width:4%">{{'MODIFY' |translate}}</th>
                  <th style="width:24%" mat-sort-header="name">{{'PHONE_NAME' |translate}}</th>
                  <th style="width:24%" mat-sort-header="gsmNumber">{{'GSM_NUMBER' |translate}}</th>
                  <th style="width:24%" mat-sort-header="modified">{{'APPROVED_AT' |translate}}</th>
                  <th style="width:24%">{{'BLOCK_MOBILE' |translate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (mobile of whitelist; track mobile) {
                  <tr>
                    @if (!mobile.toBeDeleted) {
                      <td>
                        @if (!mobile.edit) {
                          <div>
                            <span class="fa-light fa-fw fa-pen-to-square cursorPointer text-primary"
                            (click)="editMobile(mobile)"></span>
                          </div>
                        }
                        @if (mobile.edit) {
                          <div>
                            <span class="fa-light fa-fw fa-xmark cursorPointer text-danger"
                            (click)="mobile.edit = false"></span>
                            <span class="fa-light fa-fw fa-floppy-disk cursorPointer text-primary ml-2"
                            (click)="saveMobile(mobile)"></span>
                          </div>
                        }
                      </td>
                      <td>
                        @if (mobile.edit) {
                          <input class="form-control form-control-sm" type="text"
                            [(ngModel)]="mobile.newName">
                        }
                        @if (!mobile.edit) {
                          <span>{{mobile.name}}</span>
                        }
                      </td>
                      <td>
                        @if (mobile.edit) {
                          <input class="form-control form-control-sm" type="text"
                            [(ngModel)]="mobile.newGsmNumber">
                        }
                        @if (!mobile.edit) {
                          <span>{{mobile.gsmNumber ? mobile.gsmNumber : '-'}}</span>
                        }
                      </td>
                      <td>{{mobile.modified |moment: 'l LTS'}}</td>
                      <td>
                        <span class="text-danger cursorPointer" (click)="mobile.toBeDeleted = true"><span
                        class="fa-light fa-fw fa-ban"></span> {{'BLOCK_MOBILE' |translate}}</span>
                      </td>
                    }
                    @if (mobile.toBeDeleted) {
                      <td colspan="5">
                        {{'CONFIRM_MOBILE_DELETION' |translate: {mobile: mobile.name} }}
                        <span class="ml-3 text-danger cursorPointer" (click)="denyMobile(mobile)"><span
                        class="fa-light fa-fw fa-ban"></span> {{'BLOCK_MOBILE' |translate}}</span>
                        <span class="ml-3 text-primary cursorPointer" (click)="mobile.toBeDeleted = false"><span
                        class="fa-light fa-fw fa-xmark"></span> {{'CANCEL' |translate}}</span>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          }
          @if (!whitelist.length) {
            <div>{{'NO_APPROVED_MOBILES' |translate}}</div>
          }
        }
      </div>
    </div>
  }